import { httpClient } from "./httpClient";
import { getAuthHeaders } from "./authHeaders";
import { normalizeApiError } from "./normalizeApiError";

export async function apiRequest({
  method,
  path,
  data,
  params,
  headers,
  baseURL,
  responseType,
  onDownloadProgress,
  auth = true,
  errorMessage,
}) {
  try {
    const authHeaders = auth ? await getAuthHeaders() : {};
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const contentHeaders = isFormData ? {} : { "Content-Type": "application/json" };

    const response = await httpClient.request({
      method,
      url: path,
      baseURL,
      data,
      params,
      responseType,
      onDownloadProgress,
      headers: {
        ...contentHeaders,
        ...authHeaders,
        ...headers,
      },
    });

    return response.data;
  } catch (error) {
    throw normalizeApiError(error, errorMessage);
  }
}
